import * as ApiNames from '../../constants/ApiNames';
import * as SkuTypes from '../../constants/SkuTypes';
import * as QuantityPackApiNames from '../../constants/QuantityPackApiNames';

/**
 * This map indicates breakpoints when we want to change copy for a sku.
 * Format: api-name-[highestLegacyVersionNumber]
 */
export const ProductBillingNameVersions = {
  [ApiNames.SALES_HUB_STARTER]: [4],
  [ApiNames.SALES_HUB_PROFESSIONAL]: [7],
  [ApiNames.SALES_HUB_ENTERPRISE]: [3],
  [ApiNames.SERVICE_HUB_STARTER]: [3],
  [ApiNames.SERVICE_HUB_PROFESSIONAL]: [2],
  [ApiNames.SERVICE_HUB_ENTERPRISE]: [3]
};
export const QuantityPackProductApiNameOverride = {
  [ApiNames.CRM_SUITE_STARTER_BUNDLE]: [QuantityPackApiNames.ADDITIONAL_SALES_SEATS, QuantityPackApiNames.ADDITIONAL_SERVICE_SEATS],
  [ApiNames.CRM_SUITE_PROFESSIONAL_BUNDLE]: [QuantityPackApiNames.ADDITIONAL_SALES_SEATS, QuantityPackApiNames.ADDITIONAL_SERVICE_SEATS],
  [ApiNames.CRM_SUITE_ENTERPRISE_BUNDLE]: [QuantityPackApiNames.ADDITIONAL_SALES_SEATS, QuantityPackApiNames.ADDITIONAL_SERVICE_SEATS]
};

/**
 * Gets the billingNameKey for a sku (either a ProductVersion or quantityPack)
 * If the sku passed is a ProductVersion, apiName is required
 */
const getProductBillingNameKey = ({
  apiName,
  sku,
  productBillingNameVersions = ProductBillingNameVersions,
  quantityPackProductApiNameOverride = QuantityPackProductApiNameOverride
}) => {
  if (!sku) return null;
  switch (sku.skuType) {
    case SkuTypes.PRODUCT_VERSION:
      {
        if (apiName) {
          let versionToUse;
          const versionsList = productBillingNameVersions[apiName];
          if (versionsList) {
            versionToUse = versionsList.sort().reverse().find(versionSearch => versionSearch <= sku.versionNumber);
          }
          return versionToUse ? `${apiName}-${versionToUse}` : apiName;
        }
        console.error('Must pass apiName to get the billingNameKey of a ProductVersion');
        return null;
      }
    case SkuTypes.QUANTITY_PACK:
      {
        const productApiName = sku.productApiName;
        const quantityPackApiName = sku.quantityPackApiName;
        const productApiNameOverride = quantityPackProductApiNameOverride[productApiName] || [];
        const useProductSpecificName = productApiNameOverride.includes(quantityPackApiName);
        return useProductSpecificName ? `${quantityPackApiName}_${productApiName}` : quantityPackApiName;
      }
    default:
      return null;
  }
};
export default getProductBillingNameKey;